import { render, staticRenderFns } from "./ModalApproveIVN.vue?vue&type=template&id=2edad6d4&scoped=true&"
import script from "./ModalApproveIVN.vue?vue&type=script&lang=js&"
export * from "./ModalApproveIVN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edad6d4",
  null
  
)

export default component.exports